<div class="dig-dialog dialog-confirm">
  <div class="dialog-top-bar">
    <h3 class="m-0">{{ data.mainHeader | transloco }}</h3>
    <span *ngIf="!data.forcedAgree" (click)="closeDialog()" class="icon-close" inlineSVG="/icons/icon-close.svg"></span>
  </div>
  <div class="dialog-content">
    <h2 *ngIf="data.subHeader" class="header">{{ data.subHeader | transloco }}</h2>
    <p class="description">{{ data.description | transloco }}</p>
    <ul *ngIf="data.descriptionItems?.length" class="description-items">
      <li *ngFor="let item of data.descriptionItems">{{ item }}</li>
    </ul>
  </div>
  <div class="dialog-footer">
    <button *ngIf="!data.forcedAgree" class="btn btn-dark-theme btn-grey cta-btn" (click)="closeDialog(false)">
      {{ data.cancelBtnText || 'global.no' | transloco }}
    </button>
    <button
      class="btn btn-dark-theme btn-primary cta-btn"
      [class.center]="data.forcedAgree"
      (click)="closeDialog(true)"
    >
      {{ data.confirmBtnText || 'global.yes' | transloco }}
    </button>
  </div>
</div>
